import { useEffect } from 'react';

const ZohoDeskASAP = props => {
  const { isHRBClient } = props;
  const HRB_DESK =
    'https://desk.zoho.com/portal/api/web/asapApp/353388000204639023?orgId=682115237';
  const GENERAL_DESK =
    'https://desk.zoho.com/portal/api/web/asapApp/353388000197758019?orgId=682115237';
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'zohodeskasapscript';
    script.defer = true;
    script.nonce = 'your_nonce_value_if_applicable'; // Replace if using a CSP
    script.src = isHRBClient ? HRB_DESK : GENERAL_DESK;

    const existingScript = document.getElementById('zohodeskasap');
    if (!existingScript) {
      script.onload = () => {
        window.zohoDeskAsapCallbacks = (window.zohoDeskAsapCallbacks || []);
        window.zohoDeskAsapReady = callback => {
          if (window.zohoDeskAsapReadyStatus) {
            window.zohoDeskAsapCallbacks.forEach(cb => cb && cb());
            window.zohoDeskAsapCallbacks = [];
          } else {
            window.zohoDeskAsapCallbacks.push(callback);
          }
        };
      };

      document.getElementsByTagName('head')[0].appendChild(script);
    }

    return () => {
      const cleanupScript = document.getElementById('zohodeskasapscript');
      if (cleanupScript) {
        cleanupScript.remove();
      }
    };
  }, []);

  return null;
};

export default ZohoDeskASAP;
